import { render, staticRenderFns } from "./PolicyList.vue?vue&type=template&id=597a2b59&scoped=true"
import script from "./PolicyList.vue?vue&type=script&lang=js"
export * from "./PolicyList.vue?vue&type=script&lang=js"
import style0 from "./PolicyList.vue?vue&type=style&index=0&id=597a2b59&prod&lang=stylus&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "597a2b59",
  null
  
)

export default component.exports